export const featureFlags = {
  masterSerialCheck: {
    key: 'ff_device_master_serial_check',
    defaultValue: false,
    description: '日本語の製品登録画面で MASTER のシリアル確認案内を表示する',
    owner: 'Taiga',
    removeWhen:
      'MASTER の正式案内が全環境で恒久化し、Taiga が削除を承認したとき',
  },
} as const

export type FeatureFlagName = keyof typeof featureFlags
export type FeatureFlagValues = Record<FeatureFlagName, boolean>

export const featureFlagTiming = {
  minimumFetchIntervalMillis: 60_000,
  successCacheMillis: 60_000,
  fetchTimeoutMillis: 3_000,
  operationTimeoutMillis: 5_000,
} as const

export function defaultFeatureFlagValues(): FeatureFlagValues {
  return Object.fromEntries(
    Object.entries(featureFlags).map(([name, flag]) => [
      name,
      flag.defaultValue,
    ])
  ) as FeatureFlagValues
}
